import React, {useContext, useEffect, useRef, useState} from 'react';
import {connect} from 'react-redux';
import {withRouter} from '@computerrock/formation-router';
import {BlocksRenderer} from '@strapi/blocks-react-renderer';
import './NewsCard.scss';
import {NEWS_TIMER} from '../../utils/ftemConstants';
import {MobileDevice} from '../../index';
import * as applicationActionTypes from '../../application/applicationActionTypes';

const NewsCard = props => {
    const {newsResponse, initiateLinkViewModalFlow} = props;
    const [activeNews, setActiveNews] = useState(0);
    const [isHovered, setIsHovered] = useState(false);
    const [heights, setHeights] = useState(null);
    const containerRef = useRef(null);
    const {isMobile} = useContext(MobileDevice);

    const selectorNews = newsResponse && Array.isArray(newsResponse) && newsResponse.length > 0 && activeNews < newsResponse.length
        ? newsResponse[activeNews]
        : null;
    const isLink = selectorNews?.links?.[0]?.link ?? '';


    useEffect(() => {
        if (containerRef.current && newsResponse && Array.isArray(newsResponse) && newsResponse.length > 0) {
            const calculateHeights = () => {
                const children = Array.from(containerRef.current.children);
                const maxChildHeight = children.length > 0
                    ? Math.max(...children.map(child => child.offsetHeight))
                    : 0;
                setHeights(maxChildHeight);
            };
            setTimeout(calculateHeights, 0);
        }
    }, [newsResponse]);

    useEffect(() => {
        if (!newsResponse || !Array.isArray(newsResponse) || newsResponse.length < 2 || isHovered) return;

        const interval = setInterval(() => {
            setActiveNews(prevIndex => (prevIndex + 1) % newsResponse.length);
        }, NEWS_TIMER);

        return () => clearInterval(interval);
    }, [isHovered, newsResponse]);

    if (!newsResponse || !Array.isArray(newsResponse) || newsResponse.length === 0) {
        return null;
    }

    const makeAllContent = (news, index) => {
        const isVisible = index === activeNews;
        return (
            <div className={`${isVisible ? 'news-content' : 'hide-news'}`} key={index}>
                <p className="title mb-4">{news.title}</p>
                <p className="content  mb-4">
                    <BlocksRenderer content={news.text} />
                </p>
            </div>
        );
    };

    return (
        <div className={`sski-news-card__wrapper ${heights ? '' : 'opacity-clear'}`}>
            <h3 className="sski-news-card__wrapper_title has-text-centered is-4 mb-5">Short news</h3>
            <div
                className="sski-news-card__container pt-5 column is-4"
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                <div className="card-content" ref={containerRef} style={{height: heights ? heights + 'px' : 'auto'}}>
                    {newsResponse.map((singleNews, i) => makeAllContent(singleNews, i))}
                </div>
                <div className="has-text-centered">
                    <span className={`sski-news-card__link-icon icon ${isLink ? '' : 'no-visible'}`}>
                        <button
                            className="sski-news-card__link-container icon is-large sski-c-data-set__link-button--presentation"
                            onClick={() => (
                                !isMobile ? initiateLinkViewModalFlow({
                                    linkColorType: '',
                                    linkId: selectorNews?.links[0]?.itemKey, // eslint-disable-line max-len
                                }) : window.open(selectorNews?.links[0]?.links, '_blank')
                            )}
                        >
                            <img
                                alt="Presentation link icon"
                                className="sski-c-data-set__link-icon"
                                src={`${process.env.PUBLIC_URL}/assets/icons/link-presentation.svg`}
                            />
                        </button>
                    </span>
                </div>
                <div className="has-text-centered is-flex is-justify-content-center mt-4">
                    {newsResponse.map((newItem, index) => (
                        <span
                            key={index}
                            className={`dot ${index === activeNews ? 'active' : ''}`}
                            onClick={() => setActiveNews(index)}
                        >
                            <i className="fas fa-circle fa-xs" />
                        </span>
                    ))}
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        newsResponse: state.dashboard.news || [],
        newsError: state.dashboard.newsError,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        initiateLinkViewModalFlow: payload => dispatch({
            type: applicationActionTypes.OPEN_LINK_VIEW_MODAL,
            payload,
        }),
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NewsCard));
